import { defaults, isEmpty } from './utilities';

export class Params {
    constructor() {
        this.JobTitle = [];
        this.GradeBucket = [];
        this.JobCategoryCode = [];
        this.JobCategoryFamily = [];
        this.LocationName = [];
        this.Department = [];
        this.Agency = [];
        this.PositionOfferingTypeCode = [];
        this.TravelPercentage = [];
        this.PositionScheduleTypeCode = [];
        this.SecurityClearanceRequired = [];
        this.PositionSensitivity = [];
        this.ShowAllFilters = [];
        this.HiringPath = [];
        this.SocTitle = [];
        this.MCOTags = [];
        this.CyberWorkRole = [];
        this.CyberWorkGrouping = [];
        this.JobGradeCode = [];
        this.ResultsPerPage = defaults.resultsPerPage;
    }
    FromEmail?: boolean | null;
    Keyword?: string;
    JobTitle: string[];
    RemunerationMinimumAmount?: string | null;
    RemunerationMaximumAmount?: string | null;
    GradeBucket: string[];
    JobCategoryCode: string[];
    JobCategoryFamily: string[];
    LocationName: string[];
    Department: string[];
    Agency: string[];
    ExcludeOrganizations?: boolean;
    PositionOfferingTypeCode: string[];
    TravelPercentage: string[];
    PositionScheduleTypeCode: string[];
    RelocationIndicator?: string | boolean | null;
    TeleworkIndicator?: string | boolean | null;
    RemoteIndicator?: string | boolean | null;
    SecurityClearanceRequired: string[];
    PositionSensitivity: string[];
    JobGradeCode: string[];
    SortField?: string;
    SortDirection?: string;
    Page?: string;
    ShowAllFilters: string[];
    GradeSearch?: boolean;
    SavedSearchID?: number;
    SavedSearchName?: string;
    Radius?: string;
    EmailFrequency?: string;
    HiringPath: string[];
    CustomWhoMayApply?: string;
    UniqueSearchID?: string;
    SocTitle: string[];
    DocumentID?: number;
    URL?: string;
    ResultsPerPage?: number;
    IsAuthenticated?: boolean;
    MCOTags: string[];
    CyberWorkRole: string[];
    CyberWorkGrouping: string[];
    CustomMcoTag?: string;
    IncludeInternal?: boolean;
    TotalResults?: number;
    SupervisoryStatus?: boolean;
}

export function DefaultExistingParams(existingParam: Params): Params {
    if (!existingParam.JobTitle) { existingParam.JobTitle = [] }
    if (!existingParam.GradeBucket) { existingParam.GradeBucket = [] }
    if (!existingParam.JobCategoryCode) { existingParam.JobCategoryCode = [] }
    if (!existingParam.JobCategoryFamily) { existingParam.JobCategoryFamily = [] }
    if (!existingParam.LocationName) { existingParam.LocationName = [] }
    if (!existingParam.Department) { existingParam.Department = [] }
    if (!existingParam.Agency) { existingParam.Agency = [] }
    if (!existingParam.PositionOfferingTypeCode) { existingParam.PositionOfferingTypeCode = [] }
    if (!existingParam.TravelPercentage) { existingParam.TravelPercentage = [] }
    if (!existingParam.PositionScheduleTypeCode) { existingParam.PositionScheduleTypeCode = [] }
    if (!existingParam.SecurityClearanceRequired) { existingParam.SecurityClearanceRequired = [] }
    if (!existingParam.PositionSensitivity) { existingParam.PositionSensitivity = [] }
    if (!existingParam.ShowAllFilters) { existingParam.ShowAllFilters = [] }
    if (!existingParam.HiringPath) { existingParam.HiringPath = [] }
    if (!existingParam.SocTitle) { existingParam.SocTitle = [] }
    if (!existingParam.MCOTags) { existingParam.MCOTags = [] }
    if (!existingParam.CyberWorkRole) { existingParam.CyberWorkRole = [] }
    if (!existingParam.CyberWorkGrouping) { existingParam.CyberWorkGrouping = [] }
    if (!existingParam.JobGradeCode) { existingParam.JobGradeCode = [] }

    return existingParam;
}

/**
 * Merge the values of params1 and params2. For array properties, the arrays are combined.
 * For non-array properties, it keeps existing params1 values and sets unset params1 values to the params2 values.
 * @param params1 First Params object (takes precedence)
 * @param params2 Second Params object
 * @returns A new Params object
 */
export function MergeParams(params1: Params, params2: Params): Params {
    const p1 = DefaultExistingParams(structuredClone(params1));
    const p2 = DefaultExistingParams(structuredClone(params2));

    p1.JobTitle = [...new Set(p1.JobTitle.concat(p2.JobTitle))];
    p1.GradeBucket = [...new Set(p1.GradeBucket.concat(p2.GradeBucket))];
    p1.JobCategoryCode = [...new Set(p1.JobCategoryCode.concat(p2.JobCategoryCode))];
    p1.JobCategoryFamily = [...new Set(p1.JobCategoryFamily.concat(p2.JobCategoryFamily))];
    p1.LocationName = [...new Set(p1.LocationName.concat(p2.LocationName))];
    p1.Department = [...new Set(p1.Department.concat(p2.Department))];
    p1.Agency = [...new Set(p1.Agency.concat(p2.Agency))];
    p1.PositionOfferingTypeCode = [...new Set(p1.PositionOfferingTypeCode.concat(p2.PositionOfferingTypeCode))];
    p1.TravelPercentage = [...new Set(p1.TravelPercentage.concat(p2.TravelPercentage))];
    p1.PositionScheduleTypeCode = [...new Set(p1.PositionScheduleTypeCode.concat(p2.PositionScheduleTypeCode))];
    p1.SecurityClearanceRequired = [...new Set(p1.SecurityClearanceRequired.concat(p2.SecurityClearanceRequired))];
    p1.PositionSensitivity = [...new Set(p1.PositionSensitivity.concat(p2.PositionSensitivity))];
    p1.ShowAllFilters = [...new Set(p1.ShowAllFilters.concat(p2.ShowAllFilters))];
    p1.HiringPath = [...new Set(p1.HiringPath.concat(p2.HiringPath))];
    p1.SocTitle = [...new Set(p1.SocTitle.concat(p2.SocTitle))];
    p1.MCOTags = [...new Set(p1.MCOTags.concat(p2.MCOTags))];
    p1.CyberWorkRole = [...new Set(p1.CyberWorkRole.concat(p2.CyberWorkRole))];
    p1.CyberWorkGrouping = [...new Set(p1.CyberWorkGrouping.concat(p2.CyberWorkGrouping))];
    p1.JobGradeCode = [...new Set(p1.JobGradeCode.concat(p2.JobGradeCode))];

    p1.Keyword = !isEmpty(p1.Keyword) ? p1.Keyword : !isEmpty(p2.Keyword) ? p2.Keyword : undefined;
    p1.RemunerationMinimumAmount = !isEmpty(p1.RemunerationMinimumAmount) ? p1.RemunerationMinimumAmount : !isEmpty(p2.RemunerationMinimumAmount) ? p2.RemunerationMinimumAmount : undefined;
    p1.RemunerationMaximumAmount = !isEmpty(p1.RemunerationMaximumAmount) ? p1.RemunerationMaximumAmount : !isEmpty(p2.RemunerationMaximumAmount) ? p2.RemunerationMaximumAmount : undefined;
    p1.RelocationIndicator = !isEmpty(p1.RelocationIndicator) ? p1.RelocationIndicator : !isEmpty(p2.RelocationIndicator) ? p2.RelocationIndicator : undefined;
    p1.TeleworkIndicator = !isEmpty(p1.TeleworkIndicator) ? p1.TeleworkIndicator : !isEmpty(p2.TeleworkIndicator) ? p2.TeleworkIndicator : undefined;
    p1.RemoteIndicator = !isEmpty(p1.RemoteIndicator) ? p1.RemoteIndicator : !isEmpty(p2.RemoteIndicator) ? p2.RemoteIndicator : undefined;
    p1.SortField = !isEmpty(p1.SortField) ? p1.SortField : !isEmpty(p2.SortField) ? p2.SortField : undefined;
    p1.SortDirection = !isEmpty(p1.SortDirection) ? p1.SortDirection : !isEmpty(p2.SortDirection) ? p2.SortDirection : undefined;
    p1.Page = !isEmpty(p1.Page) ? p1.Page : !isEmpty(p2.Page) ? p2.Page : undefined;
    p1.GradeSearch = !isEmpty(p1.GradeSearch) ? p1.GradeSearch : !isEmpty(p2.GradeSearch) ? p2.GradeSearch : undefined;
    p1.Radius = !isEmpty(p1.Radius) ? p1.Radius : !isEmpty(p2.Radius) ? p2.Radius : undefined;
    p1.Radius = !isEmpty(p1.Radius) ? p1.Radius : !isEmpty(p2.Radius) ? p2.Radius : undefined;
    p1.ExcludeOrganizations = !isEmpty(p1.ExcludeOrganizations) ? p1.ExcludeOrganizations : !isEmpty(p2.ExcludeOrganizations) ? p2.ExcludeOrganizations : undefined;

    return p1;
}
